import React, { useEffect, useState } from "react";
import Category from "./category/Category";
import { Link } from "react-router-dom";
import { CategoryType, AdCountType } from "../../../types/main-types/mainTypes";

interface CategoryListProps {
  categoryList: CategoryType[];
  adCount: AdCountType[];
}

function CategoryList({ categoryList, adCount }: CategoryListProps) {
  const [updatedCategoryList, setUpdatedCategoryList] = useState<CategoryType[]>([]);

   useEffect(() => {
    setUpdatedCategoryList(
      categoryList?.map((category) => {
        const categoryAdCount = adCount?.find(
          (c) => c.name === category.name
        );
        return {
          ...category,
          total_ads: categoryAdCount?.total_ads,
        };
      })
    );
  }, [categoryList, adCount]);

  return (
    <div className="d-flex align-items-start gap-2 justify-content-center flex-wrap">
      {updatedCategoryList?.map((category, index) => (
        <Link
          key={index}
          to={`/ads?page=1&categoryType=${category.name}`}
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <Category
            categoryTitle={category.name}
            categoryBgImgUrl={category.image_url}
            totalAds={category.total_ads}
          />
        </Link>
      ))}
    </div>
    // <div className="d-flex justify-content-evenly align-items-center gap-1 flex-wrap">
    //   {categoryList?.map((category, index) => (
    //     <div key={index}>
    //       <Link to={`/ads?page=1&categoryType=${category.name}&searchTerm=`}>
    //         <Category
    //           categoryTitle={category.name}
    //           categoryBgImgUrl={category.image_url}
    //         />
    //       </Link>
    //     </div>
    //   ))}
    // </div>
  );
}

export default CategoryList;
